import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AssetsResults from '../components/assetsResults'

const AssetsResultsContainer = ({
  event,
  assets,
  user,
  savedAssets,
  featureFlags,
}) => {
  return (
    <AssetsResults
      event={event}
      assets={assets}
      savedAssets={savedAssets}
      user={user}
      featureFlags={featureFlags}
    />
  )
}

AssetsResultsContainer.propTypes = {
  event: PropTypes.object.isRequired,
  assets: PropTypes.array.isRequired,
  savedAssets: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  featureFlags: PropTypes.object.isRequired,
}

const mapStateToProps = store => ({
  event: store.event.event,
  user: store.user,
  assets: store.assets.data,
  savedAssets: store.assets.savedAssets,
  featureFlags: store.featureFlags,
})

export default connect(mapStateToProps)(AssetsResultsContainer)
